export const defaultPlacement = layout => ({ offset_x: 0, offset_y: 0, scale: 1, yaw: layout === 'corner' ? 45 : 0, pitch: 0, roll: 0, opacity: 1, locked: false });
export const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
export const containRect = (width, height, imageWidth, imageHeight) => {
  const scale = Math.min(width / imageWidth, height / imageHeight);
  const w = imageWidth * scale, h = imageHeight * scale;
  return { x: (width - w) / 2, y: (height - h) / 2, width: w, height: h };
};